module.exports = __webpack_public_path__ + "img/cross-x.4d7f7c0b.svg";